<template>
  <el-container class="dashboard-container">
    <el-aside width="220px" class="cyber-aside">
      <div class="logo-container">
        <div class="logo">SDK SYSTEM</div>
        <div class="logo-underline"></div>
      </div>
      <el-menu
        :router="true"
        background-color="#1a1f35"
        text-color="#8f9bb3"
        active-text-color="#00ffff"
        class="cyber-menu">
        <el-menu-item index="/dashboard">
          <i class="el-icon-monitor"></i>
          <span>系统概况</span>
        </el-menu-item>
        <el-menu-item index="/dashboard/users" v-if="userRole === 'admin' || userRole === 'agent'">
          <i class="el-icon-user"></i>
          <span>用户管理</span>
        </el-menu-item>
        <el-menu-item index="/dashboard/products" v-if="userRole === 'admin'">
          <i class="el-icon-goods"></i>
          <span>产品管理</span>
        </el-menu-item>
        <el-menu-item index="/dashboard/clients">
          <i class="el-icon-key"></i>
          <span>授权管理</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
    
    <el-container>
      <el-header class="cyber-header">
        <div class="header-title">
          <span class="cyber-text">AUTHORIZATION CONTROL CENTER</span>
        </div>
        <div class="header-right">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              {{ username }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="profile">个人信息</el-dropdown-item>
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      
      <el-main class="cyber-main">
        <div class="cyber-content">
          <router-view></router-view>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<style scoped>
.dashboard-container {
  height: 100vh;
  background: #0a192f;
}

.cyber-aside {
  background: #1a1f35;
  border-right: 1px solid rgba(0, 255, 255, 0.1);
}

.logo-container {
  height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
}

.logo {
  color: #00ffff;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 2px;
  text-shadow: 0 0 10px rgba(0, 255, 255, 0.5);
}

.logo-underline {
  width: 50%;
  height: 2px;
  background: linear-gradient(90deg, transparent, #00ffff, transparent);
  margin-top: 5px;
}

.cyber-menu {
  border: none;
}

.cyber-menu .el-menu-item {
  height: 50px;
  line-height: 50px;
  margin: 5px 0;
}

.cyber-menu .el-menu-item:hover {
  background: rgba(0, 255, 255, 0.1) !important;
}

.cyber-menu .el-menu-item.is-active {
  background: rgba(0, 255, 255, 0.15) !important;
  border-right: 2px solid #00ffff;
}

.cyber-header {
  background: #1a1f35;
  border-bottom: 1px solid rgba(0, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  height: 60px !important;
}

.cyber-text {
  color: #00ffff;
  font-size: 16px;
  letter-spacing: 2px;
  text-shadow: 0 0 10px rgba(0, 255, 255, 0.5);
}

.header-right {
  color: #8f9bb3;
}

.el-dropdown-link {
  cursor: pointer;
  color: #8f9bb3;
}

.cyber-main {
  background: #0a192f;
  padding: 20px;
}

.cyber-content {
  background: rgba(26, 31, 53, 0.5);
  border: 1px solid rgba(0, 255, 255, 0.1);
  border-radius: 4px;
  padding: 20px;
  min-height: calc(100vh - 140px);
}

/* 添加全局动画效果 */
@keyframes glow {
  0% { box-shadow: 0 0 5px rgba(0, 255, 255, 0.2); }
  50% { box-shadow: 0 0 20px rgba(0, 255, 255, 0.4); }
  100% { box-shadow: 0 0 5px rgba(0, 255, 255, 0.2); }
}

.cyber-content {
  animation: glow 4s infinite;
}
</style>

<script>
export default {
  name: 'Dashboard',
  data() {
    return {
      username: localStorage.getItem('username') || 'Guest',
      userRole: localStorage.getItem('userRole') || ''
    }
  },
  methods: {
    handleCommand(command) {
      if (command === 'logout') {
        localStorage.removeItem('token')
        localStorage.removeItem('userRole')
        this.$router.push('/login')
      }
    }
  }
}
</script>